export default __webpack_public_path__ + "c234281bfd92b68300cd3d745a8e0201.png";